import { useEffect } from 'react';

import { jwtDecode } from 'jwt-decode';
import { useNavigate, useSearchParams } from 'react-router';

import { setGxToken, setImpostorToken } from '@/features/Auth/utils';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { storage, StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { loginTrip } from '@/slices/tripTokenSlice';
import { redirectTo } from '@/utils/navigation';

export const useTokenAuth = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [urlSearchParams] = useSearchParams();
  const urlToken = urlSearchParams.get('token');
  const gxToken = useStorageValue(StorageKeys.GxToken);
  const lastPathname = useStorageValue(StorageKeys.LastPathname);

  const isReady = Boolean(gxToken) && lastPathname === null;

  useEffect(() => {
    if (gxToken && urlToken) {
      const decoded: any = jwtDecode(urlToken);
      if (decoded.impersonatorEmail) {
        setImpostorToken(urlToken, decoded.impersonatorEmail);
        redirectTo('/');
        return;
      }
    }
    if (gxToken) {
      if (lastPathname && lastPathname !== '/login') {
        storage.remove(StorageKeys.LastPathname);
        navigate(lastPathname);
      }
    } else if (urlToken) {
      dispatch(loginTrip(urlToken)).then(result => {
        if (result.meta.requestStatus !== 'rejected') {
          setGxToken(urlToken);
        }
      });
    } else {
      navigate('/login');
    }
  }, [gxToken, urlToken, lastPathname, dispatch, navigate]);

  return { isReady };
};
